<template>
  <div :id="id" class="com-rank" :style="{height, width:'100%'}" />
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'PieChart',
  props: {
    id: {
      type: String,
      default: () => 'pieChart'
    },
    dataOptions: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: () => '320px'
    },
    unit: {
      type: String,
      default: () => '人'
    }
  },
  data () {
    return {
      myEchart: ''
    }
  },
  watch: {
    dataOptions () {
      if (this.dataOptions.length) {
        this.$nextTick(() => {
          this.initChart()
        })
      }
    }
  },
  mounted () {

    // 监测视口大小
    window.addEventListener('resize', () => {
      setTimeout(() => {
        this.myEchart && this.myEchart.resize()
      }, 800)
    })
    this.initChart()
  },
  methods: {
    initChart () {
      const dataOptionsArray = []
      if (this.dataOptions.length > 0) {
        this.dataOptions.map(item => {
          dataOptionsArray.push({
            name: item.name,
            value: item.value ? item.value : 0,
            source: item.source ? item.source : 0
          })
        })
      } else {
        dataOptionsArray.push(
          { name: '暂无数据', value: 0 }
        )
      }

      const colors = {
        1: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
              offset: 0, color: '#658AFF' // 0% 处的颜色
          }, {
              offset: 1, color: '#3665FC' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        },
        2: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
              offset: 0, color: '#93EED2' // 0% 处的颜色
          }, {
              offset: 1, color: 'rgba(64, 194, 142, 0.85)' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        },
        3: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
              offset: 0, color: '#A48CFD' // 0% 处的颜色
          }, {
              offset: 1, color: '#6C42FF' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        },
        4: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
              offset: 0, color: '#FFC56D' // 0% 处的颜色
          }, {
              offset: 1, color: '#F8A815' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        },
        5: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
              offset: 0, color: '#F5A181' // 0% 处的颜色
          }, {
              offset: 1, color: 'rgba(220, 92, 62, 0.85)' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        },
        6: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
              offset: 0, color: '#22E9F2' // 0% 处的颜色
          }, {
              offset: 1, color: '#04B8D3' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        },
        8: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
              offset: 0, color: '#F5A181' // 0% 处的颜色
          }, {
              offset: 1, color: 'rgba(220, 92, 62, 0.85)' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        }
      }

      dataOptionsArray.forEach(v=>{
        v.itemStyle = {
          color: colors[v.source]
        }
        v.label = {
          color: 'rgba(0, 0, 0, 0.65)',
          fontSize: 12
        }
        v.labelLine = {
          lineStyle: {
            color: 'rgba(0, 0, 0, 0.45)'
          }
        }
      })
      this.myEchart = echarts.init(document.getElementById(this.id))
      const winW = document.body.clientWidth
     
      this.myEchart.setOption({
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 20,
          bottom: 20,
          icon: 'circle',
          z:10,
          formatter: function (name) {
            const item = dataOptionsArray.find(item => item.name === name);
            const displayName = echarts.format.truncateText(name, 100, '14px Microsoft Yahei', '…')
            return `{a|${displayName}} {b|${item && item.value > 0 ? item.value.toLocaleString() : 0}家}`; 
          },
          // tooltip: {
          //   show: true,
          //   trigger: 'item'
          // }
        },
        textStyle: {
        rich: {
            a: {
              width: 80
            },
            b: {
              width: 80
            }
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c}家  ({d}%)'
        },
        series: [
          {
            type: 'pie',
            radius: winW < 1440?['40%', '70%']:['50%', '90%'],
            left: '-180px',
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 0,
              borderColor: '#fff',
              borderWidth: 1
            },
            label: {
              formatter: '{d}%',
              show: false,
              position: 'center'
            },
            labelLine: {
              show: true,
              normal: { // 设置引导线长度
                show: true,
                length: 10
              },
              lineStyle: {
                color: 'red'
              }
            },
            data: dataOptionsArray
          }
        ]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.com-rank {
  background-color: #fff !important;
}
</style>
